<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation2
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.storeName"
              placeholder="请输入店名"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.phone"
              placeholder="请输入联系电话"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.storeTypeIds"
              multiple
              clearable
              collapse-tags
              placeholder="请选择终端类型"
              style="width:100%"
            >
              <el-option
                v-for="item in storeTypeOptions"
                :key="item.data"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-col>
          <el-col style="width:60px; padding-left:10px;">
            <el-button
              type="primary"
              @click="searchData()"
            >
              搜索
            </el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 数据列表 -->
      <custom-table2
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="addFun"
        @edit="editFun(arguments)"
        @dblclick="viewFun(arguments)"
        @view="viewFun(arguments)"
        @delete="deleteFun(arguments)"
        @export="batchExport(masterList)"
        @start="startFun(arguments)"
        @stop="stopFun(arguments)"
        @changeManager="changeManagerFun(arguments)"
      />
    </div>

    <!-- 新增 修改-->
    <add-edit-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditTitle"
      :dialog-visible.sync="dialogAddEditVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />

    <!-- 查看 -->
    <view-dialog
      :data-id="id"
      :dialog-title="dialogViewTitle"
      :dialog-visible.sync="dialogViewVisible"
      :master-table-key="masterList.tableKey"
    />

    <!-- 变更维护人 -->
    <change-manager-dialog
      :data-id="id"
      :dialog-title="'变更维护人员'"
      :dialog-visible.sync="dialogChangeVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation2 from '@/components/TableOperation2'
// 列表设置tableKeyMixin
import tableOperationMixin2 from '@/mixin/tableOperationMixin2'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 导出 batchExportMixin
import batchExportMixin2 from '@/mixin/batchExportMixin2'
// 定义表头颜色，高度，搜索，获取数据Mixin
import tableCustomMixin2 from '@/mixin/tableCustomMixin2'
// 新增 修改
import addEditDialog from './components/addEditDialog'
// 查看
import viewDialog from './components/viewDialog'
// 变更维护人
import changeManagerDialog from './components/changeManagerDialog'
// API
import { loadStoreInfoListDataApi, exportStoreInfoListDataApi, updateStoreInfoStatusApi, deleteStoreInfoApi } from '@/api/v2/store';
import { listDictApi } from '@/api/v2/dict';

export default {
  name: 'SystemSpecialStoreInfo',
  components: {
    CustomTable2,
    TableOperation2,
    addEditDialog,
    viewDialog,
    changeManagerDialog
  },
  mixins: [tableCustomMixin2, tableOperationMixin2, batchExportMixin2],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'special_store_archives_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['special_store_info_add'],
            prop: 'add',
            label: '新增',
            method: 'add'
          },
          {
            permissionSigns: ['special_store_info_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['special_store_info_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['special_store_info_del'],
            prop: 'delete',
            label: '作废',
            method: 'delete'
          },
          {
            permissionSigns: ['special_store_info_start'],
            prop: 'start',
            label: '恢复维护',
            method: 'start'
          },
          {
            permissionSigns: ['special_store_info_stop'],
            prop: 'stop',
            label: '停止维护',
            method: 'stop'
          },
          {
            permissionSigns: ['special_store_info_change_manger'],
            prop: 'change',
            label: '变更维护人',
            method: 'changeManager'
          },
          {
            permissionSigns: ['special_store_info_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          storeName: '',
          phone: '',
          storeTypeIds: [],
          billType: 2
        }
      },
      id: null,
      eventType: '',
      // 新增\修改
      dialogAddEditTitle: '',
      dialogAddEditVisible: false,
      // 查看
      dialogViewTitle: '查看特殊终端信息',
      dialogViewVisible: false,
      // 变更维护人
      dialogChangeVisible: false,
      storeTypeOptions: [],
    }
  },
  created () {
    let _this = this;
    // 初始化主列表Table列
    _this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', label: '所属省区', filterColumn: 'province_name', width: 120 },
      { prop: 'cityName', label: '所属城市', filterColumn: 'city_name', width: 120 },
      { prop: 'countyName', label: '所属区县', filterColumn: 'county_name', width: 120 },
      { prop: 'id', label: '编号', filterColumn: 'id', width: 120 },
      { prop: 'storeName', label: '店名', filterColumn: 'store_name', width: 180 },
      { prop: 'address', label: '地址', width: 200 },
      { prop: 'storeTypeValue', label: '终端业态', filterColumn: 'store_type', filterValue: 'storeType', filterArray: [{ label: '茶楼', value: 7 }, { label: '夜场', value: 8 }, { label: '网吧', value: 9 }, { label: '酒店', value: 10 }, { label: '餐饮酒楼', value: 11 }, { label: '会所', value: 12 }, { label: '汽车4S店', value: 13 }, { label: '其它', value: 14 }], width: 110 },
      { prop: 'ownerName', label: '联系人', filterColumn: 'owner_name', width: 100 },
      { prop: 'phone', label: '联系电话', width: 120 },
      { prop: 'isSellTobaccoValue', label: '是否销售卷烟', filterColumn: 'is_sell_tobacco', filterValue: 'isSellTobacco', filterArray: [{ label: '是', value: 1 }, { label: '否', value: 0 }], width: 140 },
      { prop: 'cigaretteBusinessValue', label: '卷烟经营类型', filterColumn: 'cigarette_business', filterValue: 'cigaretteBusiness', filterArray: [{ label: '零售', value: 1 }, { label: '批发', value: 2 }, { label: '批零兼营', value: 3 }], width: 140 },
      { prop: 'manageUserName', label: '维护人', filterColumn: 'manage_user_name', width: 100 },
      { prop: 'createDate', label: '建档日期', filterColumn: 'create_date', width: 120, isBetween: true },
      { prop: 'statusValue', label: '状态', filterColumn: 'status', filterValue: 'status', filterArray: [{ label: '启用', value: 1 }, { label: '停用', value: 2 }], width: 90 },
      { prop: 'remark', label: '备注', width: 200 },
      { prop: 'operatorName', label: '操作人', filterColumn: 'operator_name', width: 120 },
      { prop: 'operationTime', label: '操作时间', filterColumn: 'operation_time', width: 150, isBetween: true },
    ]
    // 默认主列表Table列
    _this.getInitTableColumns()
    _this.loadStoreTypeData()
    _this.loadTableData()
  },
  methods: {
    // 初始化终端类型
    loadStoreTypeData () {
      listDictApi({ type: 34 }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          this.storeTypeOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 请求数据
    requestData () {
      let _this = this;
      loadStoreInfoListDataApi(_this.masterList.tableQuery).then((response) => {
        const { data } = response;
        _this.handleData(data.list || []);
        _this.masterList.tableDataTotal = data.total || 0;
      }).catch()
    },
    // 新增
    addFun () {
      let _this = this;
      _this.eventType = 'add'
      _this.dialogAddEditTitle = '新增特殊终端'
      _this.dialogAddEditVisible = !this.dialogAddEditVisible
    },
    // 修改
    editFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要修改的特殊终端', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'edit'
      _this.dialogAddEditTitle = '修改特殊终端'
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible
    },
    // 变更维护人
    changeManagerFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择数据行', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.dialogChangeVisible = !_this.dialogChangeVisible
    },
    // 查看
    viewFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要查看的特殊终端', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.dialogViewVisible = !_this.dialogViewVisible
    },
    // 作废
    deleteFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要作废的特殊终端', type: 'warning' })
        return
      }
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      _this.$confirm('是否确定作废该特殊终端？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        deleteStoreInfoApi({ id: args[0].id }).then(() => {
          _this.$message({ message: '作废成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 停用
    stopFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要停止维护的特殊终端', type: 'warning' })
        return
      } else if (args[0].status === 2) {
        _this.$message({ message: '特殊终端不在维护中状态，不能停止维护', type: 'warning' })
        return
      }
      _this.$confirm('是否确定停止维护该特殊终端？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        updateStoreInfoStatusApi({ id: args[0].id, status: 2 }).then(() => {
          _this.$message({ message: '恢复维护成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 启用
    startFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要恢复维护的特殊终端', type: 'warning' })
        return
      } else if (args[0].status === 1) {
        _this.$message({ message: '零售户不在停止维护状态，不能恢复维护', type: 'warning' })
        return
      }
      _this.$confirm('是否确定将该特殊终端恢复维护？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        updateStoreInfoStatusApi({ id: args[0].id, status: 1 }).then(() => {
          _this.$message({ message: '恢复维护成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 导出数据API
    exportByPage () {
      let _this = this;
      exportStoreInfoListDataApi(_this.exportObj).then(response => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
